<mat-card>
  <div #exportContent>
    <div class="header">
      <div class="title">SAIDI and SAIFI Overview</div>
      <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <mat-card-content>
      <p>
        The SAIDI (System Average Interruption Duration Index) and SAIFI (System Average Interruption Frequency Index) calculate an average customer's yearly experience of outages (in length and duration).* These metrics estimate both day-to-day disruptions and Major Event Days (MEDS), such as outages attributed to major storms lasting multiple days, to depict a state's overall grid reliability.
      </p>
      <p>
        * All values are computed using IEEE Standards
      </p>
    </mat-card-content>
  </div>
</mat-card>
